import PropTypes from 'prop-types';
import React from 'react';
import {Tag} from 'antd';
import {need_horse_course_types} from '../config';

const YuyueStatus = ({id, type}) => {
    switch (id) {
        case -1:
            return <Tag color="error">取消预约</Tag>;
        case 0:
            return <Tag color="processing">已预约</Tag>;
        case 1:
            // 骑乘、拍摄为已上马，其余课程为已上课
            return <Tag color="warning">
                {need_horse_course_types.some(t => t === type) ? '已上马' : '已上课'}
            </Tag>;
        case 2:
            return <Tag color="success">已下课</Tag>;
        default:
            return <Tag>其他</Tag>
    }
};
YuyueStatus.propTypes = {
    id: PropTypes.number,
    type: PropTypes.number,
};
export default YuyueStatus;

